import React from "react";

const TablaGenerica = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  return (
    <table className="tabla-detalle">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Detalle</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={i}>
            <td>{formatDate(item.fecha || item.date)}</td>
            <td>{item.detalle || item.motivo || item.tipo || "-"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TablaGenerica;